import PlusIcon from "./plus.svg";
import GridIcon from "./grid.svg";
import EyeIcon from "./eye.svg";
import EyeCloseIcon from "./eye-close.svg";
import ChevronLeftIcon from "./chevron-left.svg";
import ListIcon from "./list.svg";
import BoxCubeIcon from "./box-cube.svg";
import PlugInIcon from "./plug-in.svg";
import DocsIcon from "./docs.svg";
import ChevronDownIcon from "./chevron-down.svg";
import HorizontaLDots from "./horizontal-dots.svg";
import CopyIcon from "./copy.svg";
import CheckIcon from "./check.svg";

export {
  GridIcon,
  PlusIcon,
  EyeIcon,
  EyeCloseIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ListIcon,
  BoxCubeIcon,
  PlugInIcon,
  DocsIcon,
  HorizontaLDots,
  CopyIcon,
  CheckIcon,
};
